import Vue from 'vue'
import App from './App.vue'
//import Vuesax from 'vuesax'
import firebase from 'firebase/app'
require('@firebase/auth');
require('@firebase/database');
require('@firebase/firestore');
require('@firebase/functions');
require('@firebase/messaging');
require('@firebase/storage');
require('@firebase/performance');
import router from './router'
import store from './store'
import './registerServiceWorker'
//import 'vuesax/dist/vuesax.css'
//import 'material-icons/iconfont/material-icons.css';

//Vue.use(Vuesax)
Vue.config.productionTip = false

let app = '';

//firebase.initializeApp(config);

firebase.auth().onAuthStateChanged(() =>{
  if(!app){
    app = new Vue({
      router,
      store,
      render: function (h) { return h(App) }
    }).$mount('#app');
  }
});

